import { mapGetters } from 'vuex';

import { TASK_STATUS, ROLE_PROJECT_MNG } from '@/utils/const';

export default {
  props: {
    project: {
      type: Object,
      default: () => {},
    },
    editData: {
      type: Object,
      default: () => {
        return {
          name: '',
          dueDate: new Date(),
        };
      },
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      status: TASK_STATUS,
    };
  },
  computed: {
    ...mapGetters({
      userRole: 'userRole',
    }),
    isProjectMng () {
      return this.userRole === ROLE_PROJECT_MNG;
    },
  },
};
